/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetPricingCardsParams,
  PricingCardsResponse,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get pricing cards for pricing page
 */
export const getPricingCards = (
    params?: MaybeRefOrGetter<GetPricingCardsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PricingCardsResponse>(
      {url: `/b2c/pricing_cards`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPricingCardsQueryKey = (params?: MaybeRefOrGetter<GetPricingCardsParams>,) => {
    return [
    'b2c','pricing_cards', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPricingCardsQueryOptions = <TData = Awaited<ReturnType<typeof getPricingCards>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetPricingCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingCards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPricingCardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricingCards>>> = ({ signal }) => getPricingCards(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricingCards>>, TError, TData>
}

export type GetPricingCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getPricingCards>>>
export type GetPricingCardsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get pricing cards for pricing page
 */

export function useGetPricingCards<TData = Awaited<ReturnType<typeof getPricingCards>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetPricingCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricingCards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPricingCardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






